import { Get, Put } from "./api";

export const getBDs = async () => {
  const result = await Get('/api/bds');

  return result.data;
};

export const getBDByID = async (bdId) => {
  const result = await Get(`/api/bd/${bdId}`);

  return result.data;
};

export const updateBD = async (bdId, data) => {
  const result = await Put(`/api/bd/${bdId}`, data);

  return result.data;
};
